/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Body1Inputs */

const en_to_csv_body1 = /** @type {(inputs: To_Csv_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV is a flat, rectangular format and JSON is a nested, ragged one, so this conversion is genuinely lossy in shape even when no value is lost. Every record has to occupy one row with the same columns as every other record, which means the converter has to decide what to do about keys that only some records have and values that are not scalars.`)
};

const ko_to_csv_body1 = /** @type {(inputs: To_Csv_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV는 평평한 직사각형 형식이고 JSON은 중첩되고 들쭉날쭉한 형식이므로, 값이 하나도 사라지지 않아도 이 변환은 형태 면에서 실제로 손실이 있습니다. 모든 레코드가 다른 모든 레코드와 같은 열을 가진 한 행을 차지해야 하며, 이는 일부 레코드에만 있는 키와 스칼라가 아닌 값을 어떻게 할지 변환기가 결정해야 한다는 뜻입니다.`)
};

const ja_to_csv_body1 = /** @type {(inputs: To_Csv_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV は平坦な矩形の形式で JSON はネストした不揃いの形式なので、値が 1 つも失われなくても、この変換は形の面で実際に損失があります。すべてのレコードがほかのすべてのレコードと同じ列を持つ 1 行を占めなければならず、つまり一部のレコードにしかないキーとスカラーでない値をどうするか、変換器が決めなければなりません。`)
};

/**
* | output |
* | --- |
* | "CSV is a flat, rectangular format and JSON is a nested, ragged one, so this conversion is genuinely lossy in shape even when no value is lost. Every record h..." |
*
* @param {To_Csv_Body1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_body1 = /** @type {((inputs?: To_Csv_Body1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Body1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_body1(inputs)
	if (locale === "ko") return ko_to_csv_body1(inputs)
	return ja_to_csv_body1(inputs)
});